import { connect } from 'react-redux'
import SlidePreviewList from './slide-preview-list.jsx'
import { setActiveSlideId, setPreviewDragging } from '../redux/builder.actions'
import { getActiveSlideId, isDragging } from '../redux/builder.selectors'
import {
  getOrderedSlides,
  getPresentation
} from '../../../../../stores/presentation/presentation.selectors'
import { reorderSlides } from '../../../../../stores/presentation/presentation.actions'
import { arrayMove } from 'react-sortable-hoc'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  return {
    presentation: getPresentation(state),
    activeSlideId: getActiveSlideId(state),
    isDragging: isDragging(state),
    slides: getOrderedSlides(state),
    presentationId: getPresentation(state).id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  setActiveSlideId: id => dispatch(setActiveSlideId(id)),
  onSortStart: () => dispatch(setPreviewDragging(true)),
  onSortEnd: ({ oldIndex, newIndex }) =>
    dispatch(
      reorderSlides(
        stateProps.presentationId,
        arrayMove(stateProps.slides, oldIndex, newIndex).map(slide => slide.id)
      )
    ).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SlidePreviewList)
